'use client';
import FavouriteToggleButton from './FavouriteToggleButton';
import useFavouriteToggle from './useFavouriteToggle';
import Toast from '@/client/components/Toast';

type Props = {
  game: GameFragment;
  isGameFavourite?: boolean;
  toastTranslations: Record<string, string>;
  newThumbsEnabled?: boolean;
  revalidateFavoriteGame: (tag: string) => Promise<void>;
};

const FavouriteToggle: FC<Props> = ({
  game,
  toastTranslations,
  isGameFavourite,
  newThumbsEnabled,
  revalidateFavoriteGame,
}) => {
  const {
    isFavourite,
    isToastOpen,
    toastMessage,
    handleClick,
    handleToastChange,
  } = useFavouriteToggle({
    toastTranslations,
    game,
    isGameFavourite,
    revalidateFavoriteGame,
  });

  return (
    <>
      <span
        data-gtm-event-category="image_button"
        data-gtm-event-action="toggle_favorite"
        data-gtm-event-info={game.id}
      >
        <FavouriteToggleButton
          newThumbsEnabled={newThumbsEnabled}
          onClick={handleClick}
          isFavourite={isFavourite}
          gameId={game.id}
        />
      </span>
      <Toast
        isOpen={isToastOpen}
        onOpenChange={handleToastChange}
        message={toastMessage}
        variant="success"
      />
    </>
  );
};

export default FavouriteToggle;
